module.exports = __webpack_public_path__ + "img/leak-detection.efd4f95d.svg";